module.exports = __webpack_public_path__ + "media/images/covers/Roadmap-to-Ivy-Leagues-Cover-8a3c4d5bb5fa5c0745420ec5c61fdf12.png";